<template>
  <div>
    <a-form layout="inline" @keyup.enter.native="loadData(1)">
      <a-form-item :label="$t('date')">
        <a-range-picker format="DD-MM-YYYY" v-model="form.dateRange" style="width: 280px"></a-range-picker>
      </a-form-item>
      <a-form-item :label="$t('investorList.tzrsjh')">
        <a-input :placeholder="$t('enter')" v-model="form.phone" style="width: 200px"></a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="loadData(1)">{{ $t('search') }}</a-button>
      </a-form-item>
    </a-form>
    <a-table
      :columns="i18nColumns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      ref="table"
      size="middle"
      rowKey="id"
      bordered
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="downloadInvoice(record)">{{ $t('platformCollection.download') }}</a>
      </span>
    </a-table>
    <div style="margin-top: 15px; text-align: right">
      <v-pagination
        v-if="total"
        :page-num="form.pageNum"
        :page-size="form.pageSize"
        :total="total"
        @change="handleTableChange"
      />
    </div>
  </div>
</template>
<script>
import { filterObj } from '@/utils/util'
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'

export default {
  name: 'InvestmentInvoice',
  data() {
    return {
      loading: false,
      form: {
        pageNum: 1,
        pageSize: 30,
        dateRange: undefined,
        phone: undefined,
      },
      dataSource: [],
      total: 0,
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'name',
          align: 'left',
          dataIndex: 'invoiceName',
        },
        {
          title: this.$t('investorList.cz'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    i18nColumns() {
      return this.columns.map((col) => ({
        ...col,
        title: this.$t(col.title),
      }))
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    getQueryParams() {
      const data = {
        ...this.form,
        startDate:
          this.form.dateRange && this.form.dateRange[0] ? this.form.dateRange[0].format('YYYY-MM-DD') : undefined,
        endDate:
          this.form.dateRange && this.form.dateRange[1] ? this.form.dateRange[1].format('YYYY-MM-DD') : undefined,
      }
      delete data.dateRange
      return filterObj(data)
    },
    downloadInvoice(record) {
      const file = {
        fileUrl: '/api/web/webpublic/invoice/download?invoiceId=' + record.id,
        fileName: record.invoiceName + '.pdf',
      }
      this.loading = true
      exportFile(file)
        .catch((e) => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadData(pageNum) {
      if (pageNum) {
        this.form.pageNum = pageNum
      }
      this.loading = true
      const params = this.getQueryParams()
      // Needs to be replaced with actualAPICall
      // Temporarily use mock data
      setTimeout(() => {
        this.dataSource = [
          // { id: 1, invoiceName: '_202512111106' },
          // { id: 2, invoiceName: '_202512111106' },
          // { id: 3, invoiceName: '_202512111106' },
          // { id: 4, invoiceName: '_202512111106' },
          // { id: 5, invoiceName: '_202512111106' },
          // { id: 6, invoiceName: '_202512111106' },
          // { id: 7, invoiceName: '_202512111106' },
          // { id: 8, invoiceName: '_202512111106' },
          // { id: 9, invoiceName: '_202512111106' },
          // { id: 10, invoiceName: '_202512111106' },
        ]
        this.total = 10
        this.loading = false
      }, 500)
    },
  },
}
</script>
<style scoped>
@import '~@/assets/less/common.less';
</style>
